module.exports = __webpack_public_path__ + "img/game-boy-advance.181ab4b5.png";